/**
 * Unified chart palette — every series colour resolves through the active
 * colour theme's CSS tokens (themes.css / index.css), so charts restyle
 * themselves when the user switches between BuiltOS Blue, Dark, Steel, etc.
 *
 *   expenses  muted slate / charcoal
 *   invoiced  navy (steel blue on Dark)
 *   received  success teal
 *   net       steel-blue line (projected balance, cumulative, rates)
 */
export const CHART = {
  expenses: "hsl(var(--chart-expenses))",
  invoiced: "hsl(var(--chart-invoiced))",
  received: "hsl(var(--chart-received))",
  net: "hsl(var(--chart-net))",
  grid: "hsl(var(--chart-grid))",
  axis: "hsl(var(--chart-axis))",
  danger: "hsl(var(--destructive))",
};

/** Axis tick styling shared by every Recharts chart. */
export const axisTick = (fontSize = 11) => ({ fontSize, fill: CHART.axis });

/** Tooltip surface shared by every Recharts chart. */
export const tooltipStyle = {
  background: "hsl(var(--popover))",
  border: "1px solid hsl(var(--border))",
  borderRadius: 8,
  color: "hsl(var(--foreground))",
  fontSize: 12,
  boxShadow: "var(--shadow-popover)",
};

/** "2026-07" -> "Jul" for axes, and "July 2026" for tooltips. */
export const fmtMonthTick = (ym) => {
  const [y, m] = String(ym || "").split("-").map(Number);
  if (!y || !m) return ym;
  return new Date(y, m - 1, 1).toLocaleString("en-AU", { month: "short" });
};
export const fmtMonthLabel = (ym) => {
  const [y, m] = String(ym || "").split("-").map(Number);
  if (!y || !m) return ym;
  return new Date(y, m - 1, 1).toLocaleString("en-AU", { month: "long", year: "numeric" });
};
